import React from "react";
import { InputSlider } from "@bookingcom/bui-react";
import { useLayoverDurationFilterController } from "../../../../../components/elements/SearchFilters/FiltersSplit/LayoverDurationFilter/useLayoverDurationFilter.controller";
import styles from "./LayoverDurationFilter.module.css";

export const LayoverDurationFilter = () => {
  const {
    isFilterAvailable,
    min,
    max,
    value,
    ariaLabel,
    label,
    renderTooltipValue,
    renderValue,
    onChange,
    onChangeCommit,
    keyForRemount
  } = useLayoverDurationFilterController();

  if (!isFilterAvailable) return null;

  return (
    <div className={styles.inputSliderWrapper}>
      <InputSlider
        key={keyForRemount}
        min={min}
        max={max}
        value={value}
        name="filters-duration"
        attributes={{ "data-testid": "flights_filters_layover_duration_slider" }}
        ariaLabel={ariaLabel}
        label={label}
        onChange={({ value }) => onChange(value)}
        onChangeCommit={({ value }) => onChangeCommit(value)}
        renderTooltipValue={renderTooltipValue}
        ariaValuetext={renderTooltipValue}
        renderValue={(val) => <span data-testid="flights_filters_layover_duration_label">{renderValue(val)}</span>}
      />
    </div>
  );
};
